import cmp from './ForgotPassword'

export default cmp
